module.exports = __webpack_public_path__ + "assets/media/sil.2f342612.png";